import { createFileRoute } from '@tanstack/react-router'
import { StaffKepegawaian } from '../../../../components/StaffKepegawaian'
import { useStaffUsers } from '../../../../hooks/useApi'

export const Route = createFileRoute('/platform/desa/$desaId/kepegawaian')({
  component: () => {
    const { desaId } = Route.useParams()
    const { data: staffData } = useStaffUsers(desaId ?? '')
    if (!desaId) return null
    const approvedStaff = (staffData?.data ?? []).filter((u: any) => u.status === 'approved')
    return <StaffKepegawaian desaId={desaId} staff={approvedStaff} />
  },
})
